
export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 px-6 overflow-hidden">
      {/* Background Industrial Machinery Silhouette */}
      <div className="absolute bottom-0 right-0 w-2/3 h-2/3 opacity-[0.08] pointer-events-none">
        <img
          src="https://public.readdy.ai/ai/img_res/0c921948535a73cca35c17fa7071a966.jpg"
          alt="Industrial machinery background"
          className="w-full h-full object-contain object-bottom"
        />
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10 w-full">
        {/* Badge */}
        <div className="inline-flex items-center justify-center px-6 py-2 border-2 border-gold rounded-full bg-transparent mb-8">
          <span className="text-gold text-xs tracking-[3px] font-semibold uppercase">
            Industrial Asset Specialists
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="font-serif font-bold text-white mb-8 leading-tight">
          <span className="block text-5xl md:text-7xl lg:text-8xl">Giving Assets</span>
          <span className="block text-5xl md:text-7xl lg:text-8xl">a Second</span>
          <span className="block text-5xl md:text-7xl lg:text-8xl">Life.</span>
        </h1>

        {/* Sub-headline */}
        <p className="text-white text-lg md:text-xl font-light max-w-2xl mx-auto mb-12 leading-relaxed">
          Specialists in high-value asset liquidation, industrial sales, and inventory management solutions.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <a
            href="mailto:info@nextlifeasset.com"
            className="px-8 py-4 bg-gold text-black rounded-full font-semibold text-base hover:bg-warmGold hover:scale-105 transition-all duration-300 flex items-center space-x-2 cursor-pointer whitespace-nowrap"
          >
            <span>Get Started</span>
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="mailto:info@nextlifeasset.com"
            className="px-8 py-4 border-2 border-gold text-white rounded-full font-semibold text-base hover:bg-gold hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            View Inventory
          </a>
        </div>
      </div>
    </section>
  );
}
